import './App.css';

// Componenetes
import Header from './componentes/header/Header';
import Presentacion from './componentes/presentacion/Presentacion';
import Portfolio from './componentes/portfolio/Portfolio';
import Footer from './componentes/footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Presentacion />
      <Portfolio />
      <Footer />
    </div>
  );
}

export default App;
